import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../../services/api";
import useEventoStore from "../../../stores/useEventoStore";
import EditorPublicacion from "../../../components/publicacion/EditorPublicacion";

/* Nueva publicación de un evento: /eventos/:id/publicaciones/nueva */
export const CrearPublicacion = () => {
  const { id } = useParams();
  const history = useHistory();
  const [evento, setEvento] = useState(null);

  useEffect(() => {
    useEventoStore.getState().fetchEvento(id).then((data) => setEvento(data?.evento ?? null));
    api.publicaciones.getAll(id, "", 1, 1).then((response) => {
      const existente = response.status === "success" ? response.data?.publicaciones?.[0] : null;
      if (existente) history.replace(`/eventos/${id}/publicaciones`);
    });
  }, [id, history]);

  const crear = async (payload) => {
    try {
      const response = await api.publicaciones.createPublicacion(payload);
      if (response.status !== "success") {
        toast.error(response.message || "No se pudo crear la publicación.");
        return;
      }
      toast.success("Publicación creada.");
      history.push(`/eventos/${id}/publicaciones`);
    } catch (error) {
      toast.error("No se pudo conectar con el servidor.");
    }
  };

  return (
    <div className="d-flex justify-content-center px-2 mt-4">
      <div style={{ maxWidth: "700px", width: "100%" }}>
        <h2 className="mb-1">Nueva publicación</h2>
        <p className="mb-0">Así se va a ver tu evento en el inicio. Editá la tarjeta directamente.</p>
        <EditorPublicacion evento={evento} eventoId={id} onSubmit={crear} textoSubmit="Crear publicación" />
      </div>
    </div>
  );
};
